import { IconWrapper } from './IconWrapper'
import { IIconProps } from './props'

export function ServicesIcon(props: IIconProps) {
  return (
    <IconWrapper {...props}>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.2416 18.0801V26.4001M26.4016 22.2401H18.0816M13.9216 9.7601C13.9216 12.0576 12.0591 13.9201 9.76156 13.9201C7.46406 13.9201 5.60156 12.0576 5.60156 9.7601C5.60156 7.46259 7.46406 5.6001 9.76156 5.6001C12.0591 5.6001 13.9216 7.46259 13.9216 9.7601ZM26.4016 9.7601C26.4016 12.0576 24.5391 13.9201 22.2416 13.9201C19.9441 13.9201 18.0816 12.0576 18.0816 9.7601C18.0816 7.46259 19.9441 5.6001 22.2416 5.6001C24.5391 5.6001 26.4016 7.46259 26.4016 9.7601ZM13.9216 22.2401C13.9216 24.5376 12.0591 26.4001 9.76156 26.4001C7.46406 26.4001 5.60156 24.5376 5.60156 22.2401C5.60156 19.9426 7.46406 18.0801 9.76156 18.0801C12.0591 18.0801 13.9216 19.9426 13.9216 22.2401Z"
          stroke="currentColor"
          strokeWidth="2.475"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconWrapper>
  )
}
